import { Tooltip } from 'fukku/Tooltip'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { AddButton } from 'product-card/components/shared/ProductSizes/AddToBag/AddToBagButton/AddButton'
import { BackInStockButton } from 'product-card/components/shared/ProductSizes/BackInStockButton/BackInStockButton'
import { useProductCardRefContext } from 'product-card/hooks/useProductCardRefContext'
import type { Product, ProductFullSizeInfo } from 'product/types/Product'
import { useMatchMedia } from 'utils/matchMedia/hooks'

import styles from 'product-card/components/shared/ProductSizes/AddToBag/AddToBagButton/AddToBagButton.module.scss'
import mq from 'utils/matchMedia/styles/MatchMediaQueries.module.scss'

interface AddToBagButtonProps {
	product?: Product
	size: ProductFullSizeInfo
	className?: string
	children?: React.ReactNode
	onClose?: () => void
}

export const AddToBagButton = ({
	product,
	size,
	className,
	children,
	onClose,
}: AddToBagButtonProps) => {
	const [islargeorgreater] = useMatchMedia([mq.islargeorgreater])
	const { t } = useLabels()

	const { productCardRef } = useProductCardRefContext()

	const isLastUnitsTooltip = size.lastUnits && islargeorgreater
	const isBackInStock = !size.available && product

	if (isLastUnitsTooltip) {
		return (
			<Tooltip
				position='bottom'
				content={
					<p className={styles.tooltipContent}>
						{t('pdp.sizeSelector.lastItems.text')}
					</p>
				}
				boundary={productCardRef}
			>
				<div id='lastUnits-container'>
					<AddButton size={size} className={className}>
						{children}
					</AddButton>
				</div>
			</Tooltip>
		)
	}

	if (isBackInStock) {
		if (islargeorgreater) {
			return (
				<Tooltip
					position='bottom'
					content={
						<p className={styles.tooltipContent}>
							{t('plp.sizeSelector.notifyMe.get.tooltip')}
						</p>
					}
					boundary={productCardRef}
				>
					<div id='backinstock-container'>
						<BackInStockButton
							size={size}
							product={product}
							className={className}
							onClose={onClose}
						>
							{children}
						</BackInStockButton>
					</div>
				</Tooltip>
			)
		}

		return (
			<BackInStockButton
				size={size}
				product={product}
				className={className}
				onClose={onClose}
			>
				{children}
			</BackInStockButton>
		)
	}

	return (
		<AddButton size={size} className={className} onClose={onClose}>
			{children}
		</AddButton>
	)
}
